import React from "react";
import { Link } from "react-router-dom";
import { NAV_CATEGORIES } from "../lib/categories";
import logoLight from "../assets/afrigate-logo-light.png";

export function Footer() {
  const cols = [
    { title: "Shop", links: [...NAV_CATEGORIES.map((c) => ({ label: c.label, to: `/shop?category=${encodeURIComponent(c.name)}` })), { label: "All products", to: "/shop" }] },
    { title: "Boxes", links: [{ label: "Family Box", to: "/boxes" }, { label: "Baby Box", to: "/boxes" }, { label: "Wellness Box", to: "/boxes" }, { label: "Luxury Box", to: "/boxes" }, { label: "Custom Box", to: "/boxes" }] },
    { title: "Company", links: [{ label: "How It Works", to: "/how-it-works" }, { label: "About Us", to: "/about" }, { label: "Track Order", to: "/track" }, { label: "Support", to: "/support" }] },
    { title: "Policies", links: [{ label: "FAQs", to: "/faqs" }, { label: "Shipping Policy", to: "/shipping" }, { label: "Returns & Refunds", to: "/returns" }, { label: "Privacy Policy", to: "/privacy" }, { label: "Terms & Conditions", to: "/terms" }] },
  ];
  return (
    <footer className="bg-[#0D530E] text-[#FBF5DD] mt-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-2 md:grid-cols-5 gap-8">
        <div className="col-span-2">
          <div className="mb-5">
            <img src={logoLight} alt="AfriGate" className="h-14 w-auto" />
          </div>
          <p className="text-[#FBF5DD]/60 max-w-xs leading-relaxed font-light">
            Africa's gateway to the world's best products. We source authentic UK goods, handle shipping and customs, and deliver to your door.
          </p>
        </div>
        {cols.map((col) => (
          <div key={col.title}>
            <p className="text-xs tracking-[0.2em] uppercase font-semibold text-[#E7E1B1] mb-4">{col.title}</p>
            <ul className="space-y-2.5 text-sm text-[#FBF5DD]/70 font-light">
              {col.links.map((l) => (
                <li key={l.label}><Link to={l.to} className="hover:text-[#E7E1B1]" style={{ transition: "color 0.2s ease" }}>{l.label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-[#FBF5DD]/10 py-6 text-center text-xs text-[#FBF5DD]/40 font-light">
        © {new Date().getFullYear()} AfriGate. 🇬🇧 UK live · 🇺🇸 USA · 🇦🇪 Dubai · 🇪🇺 Europe coming soon. Prices in GH₵ & GBP.
      </div>
    </footer>
  );
}
